import I18n from 'i18n-js'
import React from 'react'
import { Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'

const EventAllegedPerpetrators = ({ event, onChange, disabled }) => {
  const allegedPerpetrators = useSelector((state) => state.resourceReducer.allegedPerpetrators) || []

  // We handle both formats here: either an array of IDs like [1,2,3]
  // or an array of objects like [{id:1}, {id:2}, ...]
  const selectedIds = (event.allegedPerpetrators || []).map((ap) => ap.id ?? ap)

  return (
    <div>
      <p className="input-text-title mb-0">{I18n.t('EventAllegedPerpetrator')}</p>
      <div className="row no-gutters">
        {allegedPerpetrators.map((ap) => (
          <Form.Check
            key={ap.id}
            className="mr-0 col-12"
            value={selectedIds.includes(ap.id)}
            checked={selectedIds.includes(ap.id)}
            onChange={() => onChange(ap.id)}
            inline
            label={ap.label}
            type="checkbox"
            id={`alleged-perpetrator-${ap.id}`}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  )
}

export default EventAllegedPerpetrators
